import 'core-js';
import { createRoot } from 'react-dom/client';
import VeevaIDThemeProvider from './VeevaIDThemeProvider';
import App from './App';

const initReactApp = () => {
    const container = document.getElementById('veevaid');
    const root = createRoot(container);
    root.render(
        <VeevaIDThemeProvider>
            <App />
        </VeevaIDThemeProvider>,
    );
};

// USE_MOCK_APIS is defined by Webpack based on the environment flag "USE_MOCK_APIS".
// eslint-disable-next-line no-undef
if (USE_MOCK_APIS) {
    import(/* webpackChunkName: "browserMock" */ './mocks/browser').then(({ worker }) => {
        (async () => {
            await worker.start();
            initReactApp();
        })();
    });
} else {
    initReactApp();
}
